import barba from '@barba/core';


export default class TheProgramFilter {
  constructor(root) {
    this.root = root;
    this._onChangeHandler = this._onChange.bind(this);
    this.root.addEventListener('change', this._onChangeHandler, false);
  }

  _onChange() {
    barba.go(window.location.pathname + '?' + new URLSearchParams(new FormData(this.root)).toString());
  }
}
